// extracted by mini-css-extract-plugin
export default {"section":"FlashOfferSection_section__Bq0UE","inner":"FlashOfferSection_inner__lkzJr","header":"FlashOfferSection_header__7ERN0"};